import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate } from '../../utils/helpers';
import GuestForm from './GuestForm';

const RSVP = ['Yes', 'Maybe', 'No'];
const mapUrl = (f) => (f.GpsLocation ? `https://maps.google.com/?q=${encodeURIComponent(f.GpsLocation)}`
  : f.VenueAddress || f.Venue ? `https://maps.google.com/?q=${encodeURIComponent([f.Venue, f.VenueAddress, f.City].filter(Boolean).join(', '))}` : '');

// Mobile guest screen (phone browsers and the APK): stacked cards, a big
// "Add guest" button at the thumb. Logic: useGuestHome.
export default function GuestHomeMobile({ vm }) {
  const { event, displayName, loading, invitations, rsvp, savingRsvp, mine, fnName, idsOf, openAdd, openEdit, remove, formOpen, signOut } = vm;

  return (
    <div className="guest-home guest-home-mobile">
      <header className="guest-home-bar">
        <div>
          <div className="guest-home-event">{event.EventName}</div>
          <div className="muted">{displayName}</div>
        </div>
        <button className="btn light sm" onClick={signOut}>Sign out</button>
      </header>

      {loading ? <Spinner /> : (
        <>
          <h2>Your invitation</h2>
          {invitations.length === 0 && (
            <div className="card card-pad muted">You can add the people you are bringing below.</div>
          )}
          {invitations.map(inv => (
            <div key={inv.GuestId} className="card card-pad guest-invite">
              {inv.functions.map(f => (
                <div key={f.FunctionId} className="guest-invite-fn">
                  <strong>{f.FunctionName}</strong>
                  <span className="muted">{[fmtDate(f.FunctionDate), f.FunctionTime].filter(Boolean).join(' · ')}</span>
                  {f.Venue && <span className="muted">{f.Venue}</span>}
                  {mapUrl(f) && <a href={mapUrl(f)} target="_blank" rel="noreferrer">📍 Map</a>}
                </div>
              ))}
              <div className="guest-rsvp">
                {RSVP.map(a => (
                  <button key={a} className={'chip-toggle' + (inv.RSVPStatus === a ? ' on' : '')}
                    disabled={savingRsvp === inv.GuestId} onClick={() => rsvp(inv, a)}>{a}</button>
                ))}
              </div>
            </div>
          ))}

          <h2>People you are bringing <span className="count-pill">{mine.length}</span></h2>
          {mine.length === 0 && <div className="card card-pad muted">Nobody yet. Tap “Add guest”.</div>}
          <div className="guest-mine-list">
            {mine.map(r => (
              <div key={r.GuestId} className="card guest-mine-card">
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 700 }}>{[r.Surname, r.GuestName].filter(Boolean).join(' ')}</div>
                  <div className="muted" style={{ fontSize: 12 }}>
                    {[r.MobileNumber, r.FunctionNames || idsOf(r).map(fnName).join(', ')].filter(Boolean).join(' · ')}
                  </div>
                </div>
                <button className="icon-btn" onClick={() => openEdit(r)} aria-label="Edit">✎</button>
                <button className="icon-btn danger" onClick={() => remove(r)} aria-label="Remove">🗑</button>
              </div>
            ))}
          </div>
          <button className="btn primary guest-add-fab" onClick={openAdd}>+ Add guest</button>
        </>
      )}
      {formOpen && <GuestForm vm={vm} />}
    </div>
  );
}
